import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { ReactComponent as CopySvg } from 'shared/img/copy.svg'

import { useClipboard } from 'shared/hooks/useClipboard'
import { LocalePaymentKeysType } from 'shared/locale/en-US'
import { Requisite } from 'shared/models/Payments'

import { selectLocaleDict } from 'features/locale/selectors'

import { Icon } from 'components/UIKit'

import './RequisiteBlock.scss'

interface RequisiteProps {
  requisite: Requisite
}

const b = block('requisite-block')

const RequisiteBlock: React.FC<RequisiteProps> = ({ requisite }) => {
  const locale = useSelector(selectLocaleDict, shallowEqual).payment

  const { onCopy } = useClipboard({ text: requisite.value })

  return (
    <div className={b()}>
      <span className={b('text')}>{`${locale[requisite.name as LocalePaymentKeysType] ?? requisite.name}:`}</span>
      <span className={b('value')}>{requisite.value}</span>
      <span className={b('icon-wrapper')} onClick={onCopy}>
        <Icon type="copy" className={b('icon')} />
      </span>
    </div>
  )
}

export { RequisiteBlock }
